import {ButtonLink} from '@/components/ui/button-link/ButtonLink'
import {Button} from '@/components/ui/button/Button'
import {ComboboxItem, ComboboxList} from '@ariakit/react'
import styled, {css, DefaultTheme} from 'styled-components'

export const StyledGlobalSearchButton = styled(Button)`
    font-weight: 400;
    width: 180px;
`

export const StyledGlobalSearchShortcut = styled.span(
    ({theme: {palette, spacing, typography, transition}}) => css`
        font-weight: 500;
        outline: 1px solid ${palette.neutral[200]};
        color: ${palette.neutral[600]};
        padding: ${spacing * 0.5}px ${spacing * 2}px;
        margin-left: auto;
        border-radius: 12px;
        transition: ${transition};
        ${typography.textXs};

        &:hover {
            background: ${palette.neutral['white']};
        }
    `
)

export const StyledCommandMenuFooter = styled.div(
    ({theme: {palette, spacing, typography}}) => css`
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding: ${spacing * 2}px ${spacing * 4}px;
        gap: ${spacing}px;
        outline: 1px solid ${palette.neutral[100]};
        background: ${palette.neutral['50']};
        border-radius: 0 0 8px 8px;
        width: 100%;
        height: 64px;
        ${typography.textSm};
        color: ${palette.neutral[600]};
    `
)

const buttonStyles = (theme: DefaultTheme) => {
    const {palette, typography, spacing} = theme
    return css`
        display: flex;
        align-items: center;

        & span {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            border-radius: 4px;
            padding: 0 ${spacing}px;
            background: ${palette.neutral['white']};
            border: 1px solid ${palette.neutral[200]};
            color: ${palette.neutral[600]};
            ${typography.textXs};
            font-weight: 400;
        }
    `
}
export const StyledCommandMenuFooterButton = styled(Button)(
    ({theme}) => css`
        ${buttonStyles(theme)}
    `
)

export const StyledCommandMenuFooterButtonLink = styled(ButtonLink)(
    ({theme}) => css`
        ${buttonStyles(theme)}
    `
)

export const StyledCommandMenuListResults = styled.div(
    ({theme: {palette, spacing, typography}}) => css`
        padding: ${spacing * 4}px ${spacing * 4}px ${spacing * 2}px ${spacing * 4}px;
        ${typography.textSm};
        color: ${palette.neutral[500]};
        font-weight: 500;
    `
)

export const StyledCommandMenuItem = styled(ComboboxItem)(
    ({theme: {palette, spacing, typography, transition}}) => css`
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: ${spacing * 2}px;
        margin: 0 ${spacing * 2}px;
        ${typography.textSm};
        color: ${palette.neutral[600]};
        border-radius: 8px;
        cursor: pointer;
        transition: ${transition};

        &[data-active-item='true'] {
            background: ${palette.neutral['100']};
        }

        &:hover {
            background: ${palette.neutral['100']};
        }
    `
)

export const StyledCommandMenuList = styled(ComboboxList)(
    ({theme: {palette, opacities, spacing}}) => css`
        background: ${palette.neutral['white']}${opacities[20]};
        backdrop-filter: blur(4px);
        width: 100%;
        border-bottom: 1px solid ${palette.neutral[100]};
        padding: ${spacing * 2}px 0;
        height: 400px;
    `
)

export const StyledCommandMenuListLoaderBox = styled.div(
    ({theme: {spacing}}) => css`
        padding: 0 ${spacing * 2}px;
        margin: 0 ${spacing * 2}px;
        border-radius: 8px;

        & svg {
            border-radius: 8px;
        }
    `
)

export const StyledPopoverItem = styled.div<{$isSelected?: boolean}>(
    ({theme: {palette, typography}, $isSelected}) => css`
        ${typography.textSm}
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 8px 12px;
        cursor: pointer;
        border-radius: 8px;
        color: ${palette.neutral['950']};
        font-weight: 400;
        transition: background-color 0.2s;
        width: 100%;
        min-width: 220px;
        background-color: ${$isSelected ? palette.neutral['100'] : 'transparent'};

        &:hover {
            background-color: ${palette.neutral['100']};
        }

        svg {
            width: 16px;
            height: 16px;
        }
    `
)
